import React from 'react'
import { Stack, Text } from 'src/viewLayer/components/DesignSystem'
import { ResponsiveHeader } from 'src/viewLayer/components/shared/ResponsiveHeader'

export default ({ subtitle, title }) => {
  const largeSizeHeader = 'large'

  return (
    <Stack alignItems="center" className="HeaderComponent" gap={16} padding={[0, 0, 24, 0]}>
      {title && <ResponsiveHeader largeSize={largeSizeHeader}>{title}</ResponsiveHeader>}
      {subtitle && <Text>{subtitle}</Text>}
    </Stack>
  )
}
